import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { $enum } from 'ts-enum-util'
/* eslint-disable camelcase */
import { ShipperApplicationAccessorialPolicyResponse } from 'apps/marketplace/apiTypes/shipperAccessorials'
import { ACCESSORIALS_CONFIG_BY_NAME } from '../../../shipment-details/components/ShipmentAccesorials/constants'

export enum RATE_TYPE {
  hourly = 'hour',
  daily = 'daily',
  flat_rate = 'flat rate',
}

export enum BILLING_METHOD {
  EDI = 'EDI',
  PDF = 'PDF',
  TMS = 'TMS',
  MAIL = 'Mail',
}

export enum RATE_TYPE_SELECT {
  hourly = 'Hourly',
  daily = 'Daily',
  flat_rate = 'Flat',
}

export enum RATE_INTERVAL {
  min = 'min',
  hours = 'hour(s)',
  days = 'day(s)',
}

export type ShipperAccessorial = ShipperApplicationAccessorialPolicyResponse

export type TAccessorialPolicy = {
  accessorial: ShipperAccessorial
}

export const billingMethodOptions = $enum(BILLING_METHOD).map((value, label) => ({
  label: value,
  value: label.toLowerCase(),
}))

export const rateTypeOptions = $enum(RATE_TYPE_SELECT).map((value, label) => {
  if (value === 'Flat') return { label: value, value: 'flat_rate' }
  return { label: value, value: label }
})

export const rateIntervalOptions = $enum(RATE_INTERVAL).map((value, label) => ({
  label: value,
  value: label,
}))

export const accessorialNameOptions: TSelectOpt[] = Object.entries(ACCESSORIALS_CONFIG_BY_NAME)
  .filter(([, { enabled }]) => enabled)
  .map(([, { label, value }]) => ({
    value,
    label,
  }))
  .sort((a, b) => a.label.localeCompare(b.label))

export const equipmentOptions = [
  {
    label: 'Dry Van',
    value: 3,
  },
  {
    label: 'Reefer',
    value: 2,
  },
  {
    label: 'Open Deck',
    value: 1,
  },
  {
    label: 'Specialized',
    value: 20,
  },
]

export const otherRequirementList = [
  ['podRequired', 'POD'],
  ['taxIdRequired', 'Tax ID'],
  ['authNumberRequired', 'Auth #'],
  ['inOutTimesRequired', 'In/Out Times'],
  ['receiptRequired', 'Receipt'],
]

export type TimeIntervals = 'min' | 'hours' | 'days'

const minuteConvertMap = {
  min: 1,
  hours: 60,
  days: 1440,
}

// The BE only accepts minutes for accessorial start threshold and interval
export const convertIntervalToMinutes = (minutes: number, interval: TimeIntervals): number =>
  minuteConvertMap[interval] * minutes

type ValueInterval = {
  value: number
  increments: TimeIntervals
}

/**
 * Convert number value to converted to TimeInterval (minutes/hours/day)
 * and its corresponding interval
 *
 * Assume user enters based on selected interval
 */
export const convertMinutesToInterval = (min?: number | null): ValueInterval | undefined => {
  if (!min) return undefined

  // Values between 1-59 returned in minutes
  if (min < minuteConvertMap.hours) {
    return {
      value: min,
      increments: 'min',
    }
  }

  // Values between 60-1440 returned in hours
  if (min < minuteConvertMap.days) {
    return {
      value: min / minuteConvertMap.hours,
      increments: 'hours',
    }
  }

  // Values greater than 1440 returned in days
  return {
    value: min / minuteConvertMap.days,
    increments: 'days',
  }
}
